import { defineNuxtPlugin } from '@nuxtjs/composition-api'
import createRepository from '~/repositories'

export default defineNuxtPlugin((ctx, inject) => {
	inject('api', createRepository(ctx.$axios))
})
